import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpParams, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { StorageService } from '../../services/storage.service';
import { EncryptDecryptService } from '../../services/encrypt-decrypt.service';

@Injectable()
export class QueryParameterInterceptor implements HttpInterceptor {
    constructor(
        private storageService: StorageService,
        private encryptDecryptService: EncryptDecryptService,
       
    ) {}

    intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
      
        let params = request.params;
        let headers = request.headers;
        let newHeaders = new HttpHeaders();
        let newUrl = request.url;
        let body = request.body;

        // console.log(params, headers, newHeaders, newUrl);
        params.keys().forEach((keyToEncrypt) => {
            let encodedValue = params.get(keyToEncrypt) + '';
            params = params.delete(keyToEncrypt);
            if (!!encodedValue) {
                params = params.append(keyToEncrypt, this.paddedEncryption(encodedValue));
            }
        });

        let urlParts = request.url.split('?');
        if (!!urlParts && urlParts.length > 1) {
            let paramsStr = this.getQueryParamsEncoded(request.url);
            newUrl = urlParts[0];
            if (!!paramsStr) newUrl = urlParts[0] + '?' + paramsStr;
        }
        let globalHeaders = new Set();
        globalHeaders.add('X-TENANT-ID');

        headers.keys().forEach((keyToEncrypt) => {
            if (globalHeaders.has(keyToEncrypt.toUpperCase())) {
                let encodedValue = headers.get(keyToEncrypt) + '';
                // headers = headers.delete(keyToEncrypt)
                if (!!encodedValue) {
                    newHeaders = newHeaders.append(keyToEncrypt, this.paddedEncryption(encodedValue));
                }
            } else {
                newHeaders = newHeaders.append(keyToEncrypt, headers.get(keyToEncrypt) + '');
            }
        }); 
        return next.handle(request.clone({ url: newUrl, headers: newHeaders, params, body: body }));
    }

    getQueryParamsEncoded = (url) => {
        let queryString = '';
        //create an anchor tag to use the property called search
        let anchor = document.createElement('a');
        //assigning url to href of anchor tag
        anchor.href = url;
        //search property returns the query string of url
        let queryStrings = anchor.search.substring(1);
        let params = queryStrings.split('&');

        for (let i = 0; i < params.length; i++) {
            let pair = params[i].split('=');
            //if (pair.length > 1 && !!pair[1]) {
            queryString += (!!queryString ? '&' : '') + pair[0] + '=' + decodeURIComponent(this.paddedEncryption(pair[1]));
            //}
        }
        return queryString;
    };

    paddedEncryption = (decrypted) => {
        const data = "paddedbytes::" + decrypted;
        // return this.encryptDecryptService.encrypt('' + decrypted);
       return ('' + decrypted);
    };
}
